// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__oMFdV","dialog":"Modal_dialog__fgSY7"};